import React, { useEffect } from "react"
import ApiManager from "../../classes/ApiManager"
let apiManager = ApiManager.getInstance()

const PoweredByQuoli = () => {
  useEffect(() => {
    apiManager
      .get("getPlan")
      .then((res) => {
        apiManager?._setSubscription(res?.result)
      })
      .catch((error) => {
        console.error("Error fetching data:", error)
      })
  }, [])
  return (
    <div className="d-flex justify-content-center mt-2">
      {apiManager?._getSubscription()?.name?.includes("Free") && (
        <div class="verified-section d-none align-items-center" style={{display: "none"}}>
          <a
            href="#"
            className="verified-text-tag text-decoration-none text-muted w-100"
          >
            <span style={{background:"#F1F1F1", color: "#000", padding:"3px 15px", borderRadius:"30px"}}>Powered by Quoli</span>
          </a>
        </div>
      )}
    </div>
  )
}

export default PoweredByQuoli
